import { render, staticRenderFns } from "./TimePeriods.vue?vue&type=template&id=78a5b1a8"
import script from "./TimePeriods.vue?vue&type=script&lang=js"
export * from "./TimePeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports